import { getAppUserType } from "@/config/path";
import { MODE_ENV } from "@/services/constants";
import { ADMIN_FLAG, AuthRole } from "@/store/AuthStore";
import { rootStore } from "@/store/RootStore";

const MODE = import.meta.env.VITE_MODE_APP;

/**
 * Resolves which portal API to use (admin vs restaurant).
 *
 * Priority:
 * 1. Authenticated role from auth store
 * 2. Legacy IS_ADMIN flag in localStorage
 * 3. Production build mode (admin / partner)
 * 4. Dev mode — path prefix (/admin vs /restaurant)
 */
export function resolvePortalType(
  pathname: string = window.location.pathname
): AuthRole {
  const { role } = rootStore.authStore;

  if (role === AuthRole.ADMIN || role === AuthRole.RESTAURANT) {
    return role;
  }

  if (localStorage.getItem(ADMIN_FLAG) === "true") {
    return AuthRole.ADMIN;
  }

  if (MODE === MODE_ENV.ADMIN) {
    return AuthRole.ADMIN;
  }

  if (MODE === MODE_ENV.PARTNER) {
    return AuthRole.RESTAURANT;
  }

  return getAppUserType(pathname);
}
